import style from "./style.module.scss";
import { Box, Container, Grid, Button, MenuProps, Menu, MenuItem } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { checkEmptyObj, checkIf, defaultFormat } from "../../utils";
import { ChevronIcon, Logo, LogoutIcon } from "../../assets/icons";
import useLogin from "../Auth/useLogin";
import { styled } from "@mui/material/styles";
import { useMemo, useState } from "react";
import moment from "moment";
import { setGeneralSettings } from "../../store/generalSettingsSlice";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 12,
    marginTop: theme.spacing(1),
    minWidth: 190,
    color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
    boxShadow: "0px 12px 32px 0px rgba(0, 0, 0, 0.25)",
    "& .MuiMenu-list": {
      padding: "8px 0px",
      "& > a": {
        textDecoration: "none",
        // color: theme.palette.text.fontDarkest,
        "&:not(:last-child) > li": {
          borderBottomWidth: "1px",
          borderBottomColor: theme.palette.text.light3,
          borderBottomStyle: "solid",
        },
      },
    },
    "& .MuiMenuItem-root": {
      "&": {
        padding: "12px",
        fontSize: "16px",
        lineHeight: "normal",
      },
    },
  },
}));

export default function Header() {
  const user = useSelector((state: RootState) => state.user);
  const [searchParams] = useSearchParams();
  const invitationCode = searchParams.get("code");
  const dispatch = useDispatch();
  const { logout } = useLogin();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const initials = String(user.fullName)
    .trim()
    .split(" ")
    .map((field) => field[0].toString().toUpperCase())
    .join("");

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const daysLeft = useMemo(() => {
    return moment(user.partner?.trialEndDate, defaultFormat).diff(moment(), "days");
  }, [user]);

  const popupTrial = () => {
    dispatch(setGeneralSettings({ trialPopup: true }));
  };

  return (
    <Box className={style.header_wrapper} sx={{ width: 1 }}>
      <Grid
        className={style.header}
        item
        container
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "80px" }}
      >
        <div className={style.logo_container}>
          <Link to={`/`}>
            <Logo height={35} width={200} />
          </Link>
        </div>
        <div className={style.menu_container}>
          {user.partner?.inTrial ? (
            <div className={style.inner_menu} onClick={popupTrial}>
              {`Trial Period: ${daysLeft} days left`}
            </div>
          ) : null}

          {checkEmptyObj(user) ? (
            <div className={style.buttons}>
              <Link to={`/`}>
                <Button className={style.menu_buttons} color="primary" variant="outlined" disableElevation>
                  Login
                </Button>
              </Link>
              {/* <Link to={`${checkIf(invitationCode) ? "/quick-register?code=" + invitationCode : "/join"}`}>
                  <Button
                    className={style.menu_buttons}
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={() => dispatch(resetSelection())}
                  >
                    Join Now
                  </Button>
                </Link> */}
            </div>
          ) : (
            <div className={style.menu_wrapper}>
              <div className={style.partnerMenu}>{user.partner?.name}</div>
              <div className={style.userMenu} onClick={handleClick}>
                <div className={style.icon}>{initials}</div>
                <div className={style.name}>{user.fullName}</div>
                <ChevronIcon />
              </div>
              <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <Link to={`/change-password`}>
                  <MenuItem onClick={handleClose}>Change Password</MenuItem>
                </Link>
              </StyledMenu>
              <div onClick={logout} className={style.logoutBtn}>
                <LogoutIcon />
              </div>
            </div>
          )}
        </div>
      </Grid>
    </Box>
  );
}
